import Vue from 'vue'
import VueCookies from 'vue-cookies'
import store from '../store'
Vue.use(VueCookies)
import axios from 'axios';

axios.interceptors.request.use(function(config) {
  var token = Vue.$cookies.get('token');
  if (token) {

    config.headers.Authorization = `Bearer ${token}`;
    config.headers['Content-Type'] = `application/json`;
  }
  return config;
}, function(err) {
  return Promise.reject(err);
});


let isRefreshing = false;
let subscribers = [];

axios.interceptors.response.use(response => {
  return response;
}, error => {
  console.log("refreshing")
  const { config, response: { status } } = error;
  const originalRequest = config;


  if (status === 401 && Vue.$cookies.get('refresh')) {
    if (!isRefreshing) {
      isRefreshing = true;
      store.dispatch('user/refreshToken')
        .then(newToken => {
          isRefreshing = false;
          onRrefreshed(newToken);
          subscribers = []
        });
    }

    const retryOrigReq = new Promise((resolve, ) => {
      subscribeTokenRefresh(token => {
        originalRequest.headers['Authorization'] = 'Bearer ' + token;
        resolve(axios(originalRequest));
      });
    });
    return retryOrigReq;
  } else {
    if (!Vue.$cookies.get('refresh')) {
      store.dispatch('user/logout')
    }
    return Promise.reject(error);
  }
});

function subscribeTokenRefresh(cb) {
  subscribers.push(cb);
}

function onRrefreshed() {
  subscribers.map(cb => cb());
}